/**
 * プロフィール関連のクエリキー
 */
export const profileKeys = {
  all: ["profile"] as const,
  avatarInfo: () => ["avatarInfo"] as const,
};
